import { c as _c } from "react/compiler-runtime";
import { type HotkeyItem, useHotkeys } from "@mantine/hooks";
import { AudioPlayer } from "@/services/AudioPlayerService";
import { nextPagePressed, pauseShortCutPressed, playShortCutPressed, previousPagePressed, skipPartButtonPressed } from "@/store/actions";
import { type AppDispatch, useAppDispatch, useAppSelector } from "@/store/appState";
import { preferencesSlice } from "@/store/slices/preferencesSlice";
import { selectReadingMode } from "@/store/slices/readingSessionSlice";
import { type UUID } from "@/uuid";
export const getReaderKeyboardHotkeys = (dispatch: AppDispatch, mode: "epub" | "audiobook" | "readaloud" | null, bookId: UUID) => [["ArrowLeft", () => {
  dispatch(skipPartButtonPressed({
    direction: "previous",
    context: "reader"
  }));
}], ["Shift+ArrowLeft", () => {
  dispatch(previousPagePressed());
}], ["ArrowRight", () => {
  dispatch(skipPartButtonPressed({
    direction: "next",
    context: "reader"
  }));
}], ["Shift+ArrowRight", () => {
  dispatch(nextPagePressed());
}], ["Space", () => {
  if (mode === "epub") {
    return;
  }
  if (AudioPlayer.getState().playing) {
    dispatch(pauseShortCutPressed());
  } else {
    dispatch(playShortCutPressed());
  }
}], [".", () => {
  AudioPlayer.setPlaybackRate(AudioPlayer.getState().playbackRate + 0.25);
  dispatch(preferencesSlice.actions.incrementPlaybackRate({
    target: bookId,
    value: 0.25
  }));
}], [",", () => {
  AudioPlayer.setPlaybackRate(AudioPlayer.getState().playbackRate - 0.25);
  dispatch(preferencesSlice.actions.incrementPlaybackRate({
    target: bookId,
    value: -0.25
  }));
}]] satisfies HotkeyItem[];
export const useReaderKeyboard = bookId => {
  const $ = _c(4);
  const dispatch = useAppDispatch();
  const mode = useAppSelector(selectReadingMode);
  let t0;
  if ($[0] !== bookId || $[1] !== dispatch || $[2] !== mode) {
    t0 = getReaderKeyboardHotkeys(dispatch, mode, bookId);
    $[0] = bookId;
    $[1] = dispatch;
    $[2] = mode;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  useHotkeys(t0);
};